import "./Heroes.module.css";
import Header from "@/reusable_sections/Header";
import InternationalVenturesExportArchitecture from "./sections/InternationalVenturesExportArchitecture";
import OurStandards from "./sections/OurStandards";
import ComprehensiveTradeSolutions from "./sections/ComprehensiveTradeSolutions";
import APortfolioOfOwnedOperations from "./sections/APortfolioOfOwnedOperations";
import StartYourRecovery from "./sections/StartYourRecovery";
import Footer from "@/reusable_sections/Footer";
export default function HeroesPage() {
  return <div>
      <Header />
      <InternationalVenturesExportArchitecture />
      <OurStandards />
      <ComprehensiveTradeSolutions />
      <APortfolioOfOwnedOperations />
      <StartYourRecovery />
      <Footer />
    </div>;
}